import * as React from 'react'

import BillListView from '../components/BillListView'
import useEnableBottomNavigation from '../hooks/useEnableBottomNavigation'

export default function TabArchiveScreen() {
  useEnableBottomNavigation()

  return <BillListView isArchive={true} />
}
